import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isSameDayInTimezone } from 'utils/datetime';

import { useApi } from 'services/api';
import { getConfiguredTimezone } from 'utils/datetime';

import { getQueryFromGroupId } from './utils';

const useAcknowledgeNotificationGroup = (config) => {
  const queryClient = useQueryClient();
  const api = useApi();
  const timezone = getConfiguredTimezone();

  return useMutation({
    ...config,
    mutationFn: async ({ groupId, count }) => {
      await api.post(
        `/search/bulk/acknowledge`,
        {},
        {
          params: {
            query: getQueryFromGroupId(groupId),
            context: [],
            searchType: 'O_NOTIFICATIONS',
            timezone,
          },
        },
      );

      queryClient.setQueriesData({ queryKey: ['notifications'] }, (oldData) => {
        return oldData ? oldData.filter((x) => x.groupId !== groupId) : oldData;
      });

      const [day] = groupId.split('-');

      if (isSameDayInTimezone(new Date(day), new Date())) {
        queryClient.setQueriesData({ queryKey: ['newNotifications'] }, (oldData) => {
          return {
            ...oldData,
            count: (oldData?.count || 0) - count,
          };
        });
      }
    },
  });
};

export default useAcknowledgeNotificationGroup;
